import { useSelector } from "react-redux";
import PlaceholderImage from "../../products/PlaceholderImage";
import heroImage from "../../../assets/smartbuilding/hero.jpg";

export default function HeroSection(props) {
  const { textContent, language } = { ...props };

  const isMobile = useSelector((state) => state.screen.isMobile);

  return (
    <section className="hero">
      <PlaceholderImage
        src={heroImage}
        crop={{
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
        }}
      />

      <div className={`hero-title smartbuilding ${isMobile ? "mobile" : ""}`}>
        <h1>{textContent.heroSection.title[language]}</h1>
        <h2>{textContent.heroSection.subtitle[language]}</h2>
      </div>

      <div className="hero-scroll-indicator">
        <svg
          width="28"
          height="16"
          viewBox="0 0 28 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <path
            d="M2 2L14 14L26 2"
            stroke="white"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
    </section>
  );
}
